import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import TrustSection from "./components/TrustSection";
import BlogShowcase from "./components/BlogShowcase";
import AboutStats from "./components/AboutStats";
import ServicesGrid from "./components/ServicesGrid";
import PresentationSection from "./components/PresentationSection";
import PartnersShowcase from "./components/PartnersShowcase";
import ContactCTA from "./components/ContactCTA";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <TrustSection />
        <BlogShowcase />
        <AboutStats />
        <ServicesGrid />
        <PresentationSection />
        <PartnersShowcase />
        <ContactCTA />
      </main>
      <Footer />
    </>
  );
}